const searchQuery = new URLSearchParams(window.location.search);

export const token = searchQuery.get('token');
export const isSalesType = searchQuery.get('type') === 'sale';
export const isCopyStakeType = searchQuery.get('type') === 'copystake';
export const managerId = searchQuery.get('m');
